
import '../styles/app.scss';

window.easings = {};
window.easings.ease = "cubicBezier(0.25, 0.46, 0.45, 0.94)";
window.easings.andrew = "cubicBezier(0.77, 0, 0.175, 1)";
window.easings.feebles1 = "cubicBezier(.8,.03,.25,1)";
window.easings.feebles2 = "cubicBezier(.72,.01,.25,1)";
window.easings.ease2 = "cubicBezier(.48,.1,.48,.9)";

// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function(){
	this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};

$(window).resize(function(){ Breakpoint.refreshValue(); }).resize();


// Libs
import PubSub from "underpub-js";
import Sitewide from "./classes/Sitewide";
import ComponentsLoader from "./classes/ComponentsLoader";

// Components Import -- DO NOT REMOVE COMMENT!
import LeasingPopupSlide from "../components/elements/Widgets/LeasingPopup/LeasingPopupSlide/LeasingPopupSlide";
import LeasingPopup from "../components/molecules/Widgets/LeasingPopup/LeasingPopup";
import FixedPopupButton from "../components/molecules/Misc/FixedPopupButton/FixedPopupButton"
import EmbedCode from "../components/molecules/Misc/EmbedCode/EmbedCode"
import ListingThreeUpPeople from "../components/molecules/Listing/ListingThreeUpPeople/ListingThreeUpPeople"
import GalleryMatterportSlider from "../components/molecules/Gallery/GalleryMatterportSlider/GalleryMatterportSlider"
import ListingFourUpInfoItems from "../components/molecules/Listing/ListingFourUpInfoItems/ListingFourUpInfoItems"
import ListingThreeUpNewsSlider from "../components/molecules/Listing/ListingThreeUpNewsSlider/ListingThreeUpNewsSlider"
import FooterWithContactsAndLogos from "../components/molecules/Footer/FooterWithContactsAndLogos/FooterWithContactsAndLogos"
import FormWithTextContent from "../components/molecules/Form/FormWithTextContent/FormWithTextContent"
import MapProjectMapWithInfoPopups from "../components/molecules/Map/MapProjectMapWithInfoPopups/MapProjectMapWithInfoPopups"
import NavigationPrimary from "../components/atoms/NavigationPrimary/NavigationPrimary"
import MapWithMarkersSimple from "../components/molecules/Map/MapWithMarkersSimple/MapWithMarkersSimple"
import QuoteTallSlider from "../components/molecules/Quote/QuoteTallSlider/QuoteTallSlider"
import Logos from "../components/molecules/Logos/Logos/Logos"
import FooterSimple from "../components/molecules/Footer/FooterSimple/FooterSimple"
import QuoteShortWithIcon from "../components/molecules/Quote/QuoteShortWithIcon/QuoteShortWithIcon"
import ListingThreeUpImageCardSlider from "../components/molecules/Listing/ListingThreeUpImageCardSlider/ListingThreeUpImageCardSlider"
import ListingThreeUpImageItems from "../components/molecules/Listing/ListingThreeUpImageItems/ListingThreeUpImageItems"
import ListingThreeUpImageCards from "../components/molecules/Listing/ListingThreeUpImageCards/ListingThreeUpImageCards"
import ListingThreeUpTextCards from "../components/molecules/Listing/ListingThreeUpTextCards/ListingThreeUpTextCards"
import ListingFiveUpBgImageCardsSlider from "../components/molecules/Listing/ListingFiveUpBgImageCardsSlider/ListingFiveUpBgImageCardsSlider"
import FooterFull from "../components/molecules/Footer/FooterFull/FooterFull"
import ListingFourUpImageCardsLight from "../components/molecules/Listing/ListingFourUpImageCardsLight/ListingFourUpImageCardsLight"
import ListingFourUpImageCardsDark from "../components/molecules/Listing/ListingFourUpImageCardsDark/ListingFourUpImageCardsDark"
import ButtonOutline from "../components/atoms/ButtonOutline/ButtonOutline"
import FormWithBgImage from "../components/molecules/Form/FormWithBgImage/FormWithBgImage"
import CtaNewsletterSignup from "../components/molecules/Cta/CtaNewsletterSignup/CtaNewsletterSignup"
import CtaFullWidthContent from "../components/molecules/Cta/CtaFullWidthContent/CtaFullWidthContent"
import HeroSimplePageHeading from "../components/molecules/Hero/HeroSimplePageHeading/HeroSimplePageHeading"
import VideoCentered from "../components/molecules/Video/VideoCentered/VideoCentered"
import VideoFullWidth from "../components/molecules/Video/VideoFullWidth/VideoFullWidth"
import GalleryTwoUp from "../components/molecules/Gallery/GalleryTwoUp/GalleryTwoUp"
import GalleryWideSlider from "../components/molecules/Gallery/GalleryWideSlider/GalleryWideSlider"
import GalleryGrid from "../components/molecules/Gallery/GalleryGrid/GalleryGrid"
import ContentImageSlideshowLeft from "../components/molecules/Content/ContentImageSlideshowLeft/ContentImageSlideshowLeft"
import ContentImageSlideshowRight from "../components/molecules/Content/ContentImageSlideshowRight/ContentImageSlideshowRight"
import ContentHeadingLeftWithButton from "../components/molecules/Content/ContentHeadingLeftWithButton/ContentHeadingLeftWithButton"
import ContentHeadingWithText from "../components/molecules/Content/ContentHeadingWithText/ContentHeadingWithText"
import ButtonPrimary from "../components/atoms/ButtonPrimary/ButtonPrimary"
import ContentButtonRight from "../components/molecules/Content/ContentButtonRight/ContentButtonRight"
import ContentSidebarLinks from "../components/molecules/Content/ContentSidebarLinks/ContentSidebarLinks"
import HeroBgImage from "../components/molecules/Hero/HeroBgImage/HeroBgImage"
import NavBarTransparentOverlay from "../components/elements/NavBarTransparentOverlay/NavBarTransparentOverlay"
import HeroBgImageSlider from "../components/molecules/Hero/HeroBgImageSlider/HeroBgImageSlider"
import HeroContentImage from "../components/molecules/Hero/HeroContentImage/HeroContentImage"
import Breadcrumb from "../components/elements/Breadcrumb/Breadcrumb"
import HeroContentImageSlider from "../components/molecules/Hero/HeroContentImageSlider/HeroContentImageSlider"
import NavOverlay from "../components/molecules/Navigation/NavOverlay/NavOverlay"
import NavBarStandalone from "../components/molecules/Navigation/NavBarStandalone/NavBarStandalone"

$(document).ready(function(){

	var components = [
		// Components Loader -- DO NOT REMOVE COMMENT!
{handle: ".el-LeasingPopupSlide", require: LeasingPopupSlide },
{handle: ".comp-LeasingPopup", require: LeasingPopup },
{handle: ".comp-FixedPopupButton", require: FixedPopupButton },
{handle: ".comp-EmbedCode", require: EmbedCode },
{handle: ".comp-ListingThreeUpPeople", require: ListingThreeUpPeople },
{handle: ".comp-GalleryMatterportSlider", require: GalleryMatterportSlider },
{handle: ".comp-ListingFourUpInfoItems", require: ListingFourUpInfoItems },
{handle: ".comp-ListingThreeUpNewsSlider", require: ListingThreeUpNewsSlider },
{handle: ".comp-FooterWithContactsAndLogos", require: FooterWithContactsAndLogos },
{handle: ".comp-FormWithTextContent", require: FormWithTextContent },
{handle: ".comp-MapProjectMapWithInfoPopups", require: MapProjectMapWithInfoPopups },
{handle: ".atom-NavigationPrimary", require: NavigationPrimary },
{handle: ".comp-MapWithMarkersSimple", require: MapWithMarkersSimple },
{handle: ".comp-QuoteTallSlider", require: QuoteTallSlider },
{handle: ".comp-Logos", require: Logos },
{handle: ".comp-FooterSimple", require: FooterSimple },
{handle: ".comp-QuoteShortWithIcon", require: QuoteShortWithIcon },
{handle: ".comp-ListingThreeUpImageCardSlider", require: ListingThreeUpImageCardSlider },
{handle: ".comp-ListingThreeUpImageItems", require: ListingThreeUpImageItems },
{handle: ".comp-ListingThreeUpImageCards", require: ListingThreeUpImageCards },
{handle: ".comp-ListingThreeUpTextCards", require: ListingThreeUpTextCards },
{handle: ".comp-ListingFiveUpBgImageCardsSlider", require: ListingFiveUpBgImageCardsSlider },
{handle: ".comp-FooterFull", require: FooterFull },
{handle: ".comp-ListingFourUpImageCardsLight", require: ListingFourUpImageCardsLight },
{handle: ".comp-ListingFourUpImageCardsDark", require: ListingFourUpImageCardsDark },
{handle: ".atom-ButtonOutline", require: ButtonOutline },
{handle: ".comp-FormWithBgImage", require: FormWithBgImage },
{handle: ".comp-CtaNewsletterSignup", require: CtaNewsletterSignup },
{handle: ".comp-CtaFullWidthContent", require: CtaFullWidthContent },
{handle: ".comp-HeroSimplePageHeading", require: HeroSimplePageHeading },
{handle: ".comp-VideoCentered", require: VideoCentered },
{handle: ".comp-VideoFullWidth", require: VideoFullWidth },
{handle: ".comp-GalleryTwoUp", require: GalleryTwoUp },
{handle: ".comp-GalleryWideSlider", require: GalleryWideSlider },
{handle: ".comp-GalleryGrid", require: GalleryGrid },
{handle: ".comp-ContentImageSlideshowLeft", require: ContentImageSlideshowLeft },
{handle: ".comp-ContentImageSlideshowRight", require: ContentImageSlideshowRight },
{handle: ".comp-ContentHeadingLeftWithButton", require: ContentHeadingLeftWithButton },
{handle: ".comp-ContentHeadingWithText", require: ContentHeadingWithText },
{handle: ".atom-ButtonPrimary", require: ButtonPrimary },
{handle: ".comp-ContentButtonRight", require: ContentButtonRight },
{handle: ".comp-ContentSidebarLinks", require: ContentSidebarLinks },
{handle: ".comp-HeroBgImage", require: HeroBgImage },
{handle: ".el-NavBarTransparentOverlay", require: NavBarTransparentOverlay },
{handle: ".comp-HeroBgImageSlider", require: HeroBgImageSlider },
{handle: ".comp-HeroContentImage", require: HeroContentImage },
{handle: ".el-Breadcrumb", require: Breadcrumb },
{handle: ".comp-HeroContentImageSlider", require: HeroContentImageSlider },
{handle: ".comp-NavOverlay", require: NavOverlay },
{handle: ".comp-NavBarStandalone", require: NavBarStandalone },
	];

	window.sitewide = new Sitewide();
	window.sitewide.init();

	// Getting our components loading going
	var componentsLoader = new ComponentsLoader({components: components});
	componentsLoader.initScreen();

	// setting our breakpoint value
	Breakpoint.refreshValue();

});
